const trainOverview = {
  bindings: {
    train: '<',
  },
  templateUrl: '/modules/configurationManagement/train-overview/train-overview.html',
  controller: 'TrainOverviewController',
};

angular
  .module('configuration-management.module')
  .component('trainOverview', trainOverview)
  .config(function($stateProvider) {
    $stateProvider.state('train.overview', {
      url: '/overview',
      views: {
        'traintab@train': 'trainOverview',
      },
    });
  });
